// Presentation only: creation always uses the IDs returned by the API.
export const SUPPORT_CATEGORIES = [
  {
    name: 'Product issue',
    background: '#EABEC0',
    color: '#9E1921',
    tagClass: 'bg-[#EABEC0] text-[#9E1921]',
  },
  {
    name: 'Billing issue',
    background: '#A3C7CF',
    color: '#0A4C5B',
    tagClass: 'bg-[#A3C7CF] text-[#0A4C5B]',
  },
  {
    name: 'Feature request',
    background: '#BDDDD5',
    color: '#074F3E',
    tagClass: 'bg-[#BDDDD5] text-[#074F3E]',
  },
  {
    name: 'General inquiry',
    background: '#D2B7D8',
    color: '#681A78',
    tagClass: 'bg-[#D2B7D8] text-[#681A78]',
  },
];
